import React from 'react';

// Single home for the orders list header cell, so the customer table and the
// supplier table render the same one-line uppercase label. The class itself is
// defined in pages/Orders.css next to the other shared orders-table cells.
export const renderColumnTitle = (label: string) => (
  <span className="orders-table__column-title">{label}</span>
);

export default renderColumnTitle;
